let ProductSelectedSlider;

let $mobileSlider;
let $desktopSliderModal;
let $desktopSliderThumbnailModal;
let $flickityModal;

ProductSelectedSlider = {
	init () {
		$mobileSlider = $( '.js-selected-product-mobile-slider' );
		$desktopSliderModal = $( '.js-selected-product-modal-slider' );
		$desktopSliderThumbnailModal = $( '.js-selected-product-modal-thumbnail-slider' );
		$flickityModal = $( '.flickity-modal' );

		let options = {};

		options.$mobileOption = {
			pageDots: true,
			wrapAround: true,
			cellAlign: 'center',
			percentPosition: false,
			dragThreshold: 10,
			prevNextButtons: true,
			fullscreen: false,
			on: {
				ready: function () {
					$mobileSlider.removeClass( 'invisible' );
				},
			},
		}

		options.$desktopOption = {
			pageDots: false,
			wrapAround: true,
			cellAlign: 'center',
			percentPosition: false,
			dragThreshold: 10,
			prevNextButtons: true,
			fullscreen: false,
		}

		options.$desktopSliderThumbnailModal = {
			pageDots: false,
			wrapAround: false,
			cellAlign: 'center',
			percentPosition: false,
			dragThreshold: 10,
			prevNextButtons: false,
			fullscreen: false,
			contain: true,
		}

		$mobileSlider.flickity( options.$mobileOption );
		$desktopSliderModal.flickity( options.$desktopOption );
		// $desktopSliderThumbnailModal.flickity(options.$desktopSliderThumbnailModal);

		$mobileSlider.on( 'select.flickity', () => {
			// Pause all videos
			if ( typeof window.Video === 'object' ) {
				window.Video.refs.forEach( ( item ) => {
					item.call( 'pause' );
				} );
			}

			if ( !$mobileSlider.is( ':visible' ) ) return;

			// Play video on active slide
			if ( typeof window.Video === 'object' ) {
				window.Video.refs
					.filter( ( item ) => {
						return $mobileSlider[0].contains( item.element )
							&& item.element.parentNode.classList.contains( 'is-selected' );
					} )
					.forEach( ( item ) => {
						item.call( 'play' );
					} );
			}
		} );

		$desktopSliderThumbnailModal.on( 'click', '.item', function () {
			let _this = this;
			$desktopSliderThumbnailModal.find( '.item' ).removeClass( 'is-active' );
			$( _this ).addClass( 'is-active' );
			let index = $( _this ).index();
			$desktopSliderModal.flickity( 'select', index );
		} );

	},
	sliderModal ( index ) {
		$flickityModal.modal( 'show' );
		$( 'body' ).addClass( 'product-modal-open' );

		$( document ).find( '.flickity-modal' ).off( 'shown.bs.modal' ).on( 'shown.bs.modal', function () {
			setTimeout( () => {
				$( this ).find( '.modal-dialog' ).removeClass( 'invisible' );
				$desktopSliderModal.removeClass( 'invisible' );
				$desktopSliderModal.flickity( 'resize' );
				$desktopSliderThumbnailModal.removeClass( 'invisible' );
				$desktopSliderModal.flickity( 'select', index );
				$desktopSliderThumbnailModal.find( '.item' ).removeClass( 'is-active' );
				$desktopSliderThumbnailModal.find( '.item:eq(' + index + ')' ).addClass( 'is-active' );
			}, 500 );
		} );

		$( document ).find( '.flickity-modal' ).on( 'hidden.bs.modal', function () {
			$( 'body' ).removeClass( 'product-modal-open' );
			$desktopSliderThumbnailModal.find( '.item' ).removeClass( 'is-active' );
		} );
	},
}

$( '.js-slider-modal' ).click( function () {
	let $this = $( this );
	ProductSelectedSlider.sliderModal( $this.data( 'index' ) );
} );


$( window ).resize( function () {
	if ( matchMedia( 'screen and (max-width: 1023px)' ).matches ) {
		$flickityModal.modal( 'hide' );
	}
} );

ProductSelectedSlider.init();

window.ProductSelectedSlider = ProductSelectedSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/product-selected.js